<template>
  <v-container
    fluid
    grid-list-lg
  >
    <v-toolbar
      height="65"
      app
      center
      class="baner"
    >
      <v-spacer />
      <v-avatar
        :tile="tile"
        size="60px"
      >
        <v-img :src="require('@/assets/uniq.png')" />
      </v-avatar>
      <h2 class="center">
        UNIVERSIDAD NACIONAL INTERCULTURAL DE QUILLABAMBA
      </h2>
      <v-spacer />
    </v-toolbar>
    <template>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          sm12
          md12
        >
          <v-card>
            <v-layout
              align-center
              justify-center
              row
              fill-height
            >
              <v-card-title primary-title>
                <span
                  class="success--text font-weight-bold headline align-center justify-center"
                >FORMULARIO DE PRE-INSCRIPCIÓN</span>
              </v-card-title>
            </v-layout>
          </v-card>
          <v-divider />
          <br>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step
                step="1"
                :complete="step > 1"
              >
                DATOS PRINCIPALES
              </v-stepper-step>
              <v-divider />
              <v-stepper-step
                step="2"
                :complete="step > 2"
              >
                DATOS GENERALES
              </v-stepper-step>
              <v-divider />
              <v-stepper-step step="3">
                REPORTE DE FICHA EN PDF
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-form
                ref="form"
                v-model="validForm"
                lazy-validation
                @submit.prevent="submitCreateAdmision"
              >
                <v-stepper-content step="1">
                  <!-- //{{{ -->
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      xs12
                      md6
                    >
                      <v-autocomplete
                        v-model="form.type_exam_id"
                        :items="typeexams"
                        :loading="loadingTypeexams"
                        dense
                        clearable
                        small-chips
                        label="SELECCIONAR MODALIDAD DE EXAMEN"
                        item-text="title"
                        item-value="id"
                        :rules="rules.type_exam_id"
                        :error="!!formErrores.type_exam_id"
                        :error-messages="formErrores.type_exam_id"
                      />
                    </v-flex>
                    <v-flex
                      sm6
                      xs12
                    >
                      <v-autocomplete
                        v-model="form.career_id"
                        :items="careers"
                        :loading="loadingCareers"
                        dense
                        clearable
                        small-chips
                        label="SELECCIONAR CARRERA"
                        item-text="title"
                        item-value="id"
                        :rules="rules.career_id"
                        :error="!!formErrores.career_id"
                        :error-messages="formErrores.career_id"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      sm6
                      xs12
                    >
                      <v-text-field
                        v-model="form.dni"
                        label="DNI"
                        :rules="rules.dni"
                        :error="!!formErrores.dni"
                        :error-messages="formErrores.dni"
                        :counter="8"
                        maxlength="8"
                      />
                    </v-flex>
                    <v-flex
                      sm6
                      xs12
                    >
                      <v-text-field
                        v-model="form.cdni"
                        label="CONFIRMAR DNI"
                        :rules="rules.cdni"
                        :error="!!formErrores.cdni"
                        :error-messages="formErrores.cdni"
                        :counter="8"
                        maxlength="8"
                      />
                    </v-flex>
                  </v-layout>
                  <v-btn
                    color="primary"
                    large
                    :loading="searchExisting"
                    @click="next"
                  >
                    Continuar
                  </v-btn>
                </v-stepper-content> <!-- // }}} -->
                <v-stepper-content step="2">
                  <!-- //{{{ -->
                  <app-datos-generales-001
                    ref="datosGenerales"
                    :data="form"
                    :enable-dni="false"
                    :activar-fotografia="false"
                    :pedir-requisitos="activarFotografia"
                    :must-select-place="!!decentralized"
                    :places="places"
                  />
                  <app-datos-colegio
                    ref="colegio"
                    :data="form"
                    :regions="regions"
                    :provinces="provinces"
                    :districts="districts"
                    :schools="schools"
                  />
                  <app-lugar-procedencia
                    ref="lugarProcedencia"
                    :data="form"
                    :regions="regions"
                    :provinces="provinces"
                    :districts="districts"
                  />
                  <app-lugar-nacimiento
                    ref="lugarNacimiento"
                    :regions="regions"
                    :provinces="provinces"
                    :districts="districts"
                    :amazonic="amazonic"
                    :data="form"
                    :pedir-requisitos="pedirRequisitos"
                  />
                  <app-requisitos
                    v-if="typeExam && pedirRequisitos"
                    ref="requisitos"
                    :lista-requisitos="listaRequisitos"
                  />
                  <v-btn
                    type="submit"
                    color="success"
                    :loading="processingForm"
                  >
                    GUARDAR INSCRIPCIÓN
                  </v-btn>
                  <v-btn
                    flat
                    @click="reset"
                    @click.native="step = 1"
                  >
                    CANCELAR
                  </v-btn>
                  <v-dialog
                    v-model="dialog"
                    width="600"
                  >
                    <template>
                      <v-btn
                        type="submit"
                        color="success"
                        :loading="processingForm"
                      >
                        GUARDAR INSCRIPCIÓN
                      </v-btn>
                    </template>

                    <v-card>
                      <v-toolbar
                        color="teal darken-1"
                        dark
                      >
                        <v-avatar
                          :tile="tile"
                          size="55px"
                        >
                          <v-img :src="require('@/assets/uniq.png')" />
                        </v-avatar>
                        <v-toolbar-title>
                          USTED SE ENCUENTRA PREINSCRITO
                        </v-toolbar-title>
                        <v-spacer />
                      </v-toolbar>
                      <v-divider />
                      <v-list three-line>
                        <template v-for="(item, index) in items">
                          <v-subheader
                            v-if="item.header"
                            :key="item.header"
                          >
                            {{ item.header }}
                          </v-subheader>

                          <v-divider
                            v-else-if="item.divider"
                            :key="index"
                            :inset="item.inset"
                          />

                          <v-list-tile
                            v-else
                            :key="item.title"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <img :src="item.avatar">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-list-tile-sub-title>
                                {{ item.title }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          flat
                          @click="dialog = false"
                        >
                          CANCELAR
                        </v-btn>
                        <v-btn
                          color="successful"
                          @click="dialog = false"
                        >
                          ACEPTAR
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-stepper-content> <!-- //}}} -->
              </v-form>
              <v-stepper-content step="3">
                <!-- //{{{ -->
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    md12
                  >
                    <embed
                      :src="pdf"
                      type="application/pdf"
                      width="1200"
                      height="600"
                    >
                  </v-flex>
                </v-layout>
                <v-btn
                  color="primary"
                  @click="reset"
                  @click.native="step = 1"
                >
                  Salir
                </v-btn>
              </v-stepper-content> <!-- //}}} -->
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VueAvatar } from 'vue-avatar-editor-improved'
import AppDatosGenerales001 from './datos-generales-001'
import AppDatosColegio from './datos-colegio'
import AppLugarProcedencia from './lugar-procedencia'
import AppLugarNacimiento from './lugar-nacimiento'
import AppRequisitos from './requisitos'

export default {
  metaInfo () {
    return { title: 'Universidad Nacional Intercultural de Quillabamba' }
  },
  components: {
    VueAvatar, AppDatosGenerales001, AppDatosColegio, AppLugarProcedencia, AppLugarNacimiento, AppRequisitos
  },
  data () {
    return {
      step: 1,
      activarFotografia: false,
      pedirRequisitos: false,
      dialogoAbierto: false,
      pdf: '',
      checkbox: false,
      searchExisting: false,
      tile: true,
      dialog: false,
      disabled: false,
      imageUrl: '',
      schooles: [],
      panel: [false, true],
	    tieneImagen: false,
      formErrors: {},
      formErrores: {},
      targetIssueDate: false,
      targetIssueDateYear: false,
      amazonic: false,
	  decentralized: false,
      items: [
        {
          header: 'La Dirección de Admisión revisará y validará sus documentos'
        },
        {
          avatar: require('@/assets/dos.png'),
          title:
            'Descargue su ficha de preinscripción y guardela como evidencia de su registro.'
        },
        { divider: true, inset: true },
        {
          avatar: require('@/assets/uno.png'),
          title:
            'Ingresa a https://admision.uniq.edu.pe y dale click a VERIFICA INSCRIPCION. Si su registro y documentos estan correctos podra descargar su FICHA DE INSCRIPCION.'
        },
        { divider: true, inset: true },
        {
          avatar: require('@/assets/tres.png'),
          title:
            'Si tiene observaciones de su inscripción comuniquese con el 962984333 y 914608901 dentro del plazo de inscripcion para subsanar las observaciones, en caso contrario se desestimara su preinscripción sin opción a reclamo alguno.'
        }
      ],
      typeExam: null,
      form: {
        dni: '',
        cdni: '',
        name: '',
        no_school: false,
        career_id: '',
        image: '',
        extra: ''
      },
      extraExams: ['ANDINO', 'AMAZÓNICO'],
      listaRequisitos: [],
      validForm: true,
      processingForm: false,
      processing: false,

      rules: {
        type_exam_id: [v => !!v || 'Seleccionar modalidad de requerido.'],
        career_id: [v => !!v || 'Seleccionar carrera es requerido.'],
        dni: [
          v => !!v || 'El dni es requerido.',
          v => /^[0-9]{8}$/.test(v) || 'Ingresar solo numeros y 8 digitos.'
        ],
        cdni: [
          v => !!v || 'Confirmar dni requerido.',
          v => /^[0-9]{8}$/.test(v) || 'Ingresar solo numeros y 8 digitos.'
        ]
      }
    }
  },
  computed: {
  },
  watch: {
    targetIssueDate (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    targetIssueDateYear (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    'form.type_exam_id': function () {
      this.typeExam = this.typeexams.find(x => x.id == this.form.type_exam_id)
      this.amazonic = this.typeExam && !!this.typeExam.amazonic
	  this.decentralized = (this.typeExam && this.typeExam.decentralized) || false

      this.listaRequisitos = (this.typeExam.requisites || []).map(x => ({
        ...x,
        path: '',
        url: ''
      }))
    }
  },
  computed: { // {{{
    ...mapState({
      careers: state => state.careers.careers,
      loadingCareers: state => state.careers.loadingCareers,
      typeexams: state => state.typeExams.typeexams,
      loadingTypeexams: state => state.typeExams.loadingTypeexams,
      loadingRegions: state => state.regions.loadingRegions,
      regions: state => state.regions.regions,
      loadingProvinces: state => state.provinces.loadingProvinces,
      provinces: state => state.provinces.provinces,
      loadingDistricts: state => state.districts.loadingDistricts,
      districts: state => state.districts.districts,
      loadingSchools: state => state.schools.loadingSchools,
      schools: state => state.schools.schools,
      loadingLanguages: state => state.languages.loadingLanguages,
      languages: state => state.languages.languages,
      communities: state => state.typeExams.communities,
	  places: state => state.typeExams.places
    }),
    filteredSchoolProvince () {
      let provinces = this.provinces
      return provinces.filter(o => o.region_id === this.form.school_region)
    },

    filterSchoolDistrict () {
      let districts = this.districts
      return districts.filter(o => o.province_id === this.form.school_province)
    },
    filteredSchool () {
      var schools = this.schools
      return schools
    },
    filterOriginProvince () {
      let provinces = this.provinces
      return provinces.filter(o => o.region_id === this.form.origin_region)
    },
    filterOriginDistrict () {
      let districts = this.districts
      return districts.filter(o => o.province_id === this.form.origin_province)
    },
    filterData () {
      let provinces = this.provinces
      return provinces.filter(o => o.region_id === this.form.birth_region)
    },
    filteredData () {
      let districts = this.districts
      return districts.filter(o => o.province_id === this.form.birth_province)
    }
  }, // }}}
  created () {
    this.getCareers()
    this.getExams()
    this.getRegions()
    this.getProvinces()
    this.getDistricts()
    this.getLanguages()
    this.getPlaces()
  },
  methods: {
    ...mapActions({
      replaceCurrentProduct: 'admision/replaceCurrentProduct',
      createAdmision: 'admision/createAdmision',
      getCareers: 'careers/getCareers',
      getExams: 'typeExams/getExams',
      getRegions: 'regions/getRegions',
      getProvinces: 'provinces/getProvinces',
      getDistricts: 'districts/getDistricts',
      getSchools: 'schools/getSchools',
      getVerify: 'admision/getVerify',
      getLanguages: 'languages/getLanguages',
      cargarArchivo: 'admision/cargarArchivo',
      getCommunities: 'typeExams/getCommunities',
      getPlaces: 'typeExams/getPlaces'
    }),
    validateForm () {
      if (this.pedirRequisitos) {
        for (let r of this.listaRequisitos) {
          if (!r.url) {
            this.$message.warning(
              'Debe adjuntar el archivo correspondiente al requisito ' + r.title
            )
            return false
          }
        }
      }

      /*
      console.table([
        this.form.dni,
        this.form.cdni,
        this.form.type_exam_id,
        this.form.career_id,
        this.$refs.datosGenerales.validForm,
        this.$refs.colegio.validForm,
        this.$refs.lugarProcedencia.validForm,
        this.$refs.lugarNacimiento.validForm
      ]); */

      return this.form.dni && this.form.cdni && this.form.type_exam_id,
      this.form.career_id &&
        this.$refs.datosGenerales.validForm &&
        this.$refs.colegio.validForm &&
        this.$refs.lugarProcedencia.validForm &&
        this.$refs.lugarNacimiento.validForm
    },
    alSeleccionarModalidad () {
      this.modalidad = this.modality_sustenance_url
    },
    async community () {
      try {
        let tipo = this.form.extra
        await this.getCommunities({ tipo })
      } catch (error) {
      }
    },
    salvarImagen () {
      if (!this.activarFotografia) return
      this.tieneImagen = true
      this.$refs.fotografia.src =
			this.$refs.vueavatar.getImageScaled().toDataURL()
      this.dialogoAbierto = false
    },

    next () {
      this.searchExisting = true
      this.getVerify({
        dni: this.form.dni,
        examId: this.form.type_exam_id,
        careerId: this.form.career_id
      })
        .then(response => {
          this.searchExisting = false
          // console.log(response)
          if (this.form.dni != null && this.form.dni === this.form.cdni) {
            if (this.form.type_exam_id === 0 && this.form.career_id === 0) {
              this.form.type_exam_id = this.rules.type_exam_id.validForm
              this.form.career_id = this.rules.career_id.validFor
            } else {
              this.step = 2
            }
          } else {
            this.form.dni = this.rules.dni.validForm
            this.form.cdni = this.rules.cdni.validForm
          }
        })
        .catch(error => {
          this.searchExisting = false
          this.form.dni = this.form.cdni = this.rules.dni.validForm
          this.step = 1
        })
    },
    school () {
      this.getSchools({ id: this.form.school_district_id }).then(response => {
        let schools = response.data.data
        return schools
      })
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateYear (date) {
      if (!date) return null
      const [year] = date.split('-')
      this.$refs.picker.activePicker = 'YEAR'
      this.menu = false
      return `${year}`
    },
    reset () {
      this.$refs.form.reset()
    },

    submitCreateAdmision () {
      if (!this.$refs.form.validate()) return false
      if (!this.validateForm()) return false

      this.$confirm('¿Estas seguro de son tus datos correctos?', 'Confirmar', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        // console.log(this.listaRequisitos);
        // console.log( this.$refs.datosGenerales.getFotografiaDataURL() );

        this.processingForm = true
        const sendData = {
          ...this.form,
          ...this.$refs.datosGenerales.form,
          ...this.$refs.colegio.form,
          ...this.$refs.lugarProcedencia.form,
          ...this.$refs.lugarNacimiento.form,
          image_data: this.activarFotografia ? this.$refs.datosGenerales.getFotografiaDataURL() : null,
          requisites: this.listaRequisitos.filter(x => this.pedirRequisitos).map(x => ({
            id: x.id,
            file_url: x.url,
            file_path: x.filePath
          }))
        }
        sendData.place_id = sendData.place

        this.createAdmision({ data: sendData })
          .then(response => {
            this.processingForm = false
            this.$router.push({ condition: 'sgcProductsList' })
            this.dialog = true
            this.step = 3
            this.pdf = response.data.pdf_path
          })
          .catch(err => {
            this.processingForm = false
            this.formErrors = err.response.data.errors || {}
          })
      })
        .catch(() => {
          console.log('cancel')
        })
    }
  }
}
</script>
<style scoped>
.scoped-toolbar-title {
  display: flex;
  filter: opacity(70%);
  align-items: center;
  padding-right: 1.4rem;
}
.center {
  display: flex;
  align-items: center;
  padding-right: 1.4rem;
  font-size: 25px;
  margin-inline-start: 20px;
}
.baner {
  background-color: teal;
  color: aliceblue;
}
@media only screen and (max-width: 600px) {
  .center {
    display: flex;
    align-items: center;
    padding-right: 0.5em;
    font-size: 14px;
    margin-inline-start: 20px;
  }
}
</style>
